import proj4 from 'proj4';

// Universal GPS to UTM conversion - works anywhere in the world

export const convertGPSForProject = gpsCoords => {
  try {
    // Input validation
    if (!gpsCoords || typeof gpsCoords.latitude !== 'number' || typeof gpsCoords.longitude !== 'number') {
      return {
        latitude: 0,
        longitude: 0,
        accuracy: 0
      };
    }

    // Validate GPS ranges
    if (gpsCoords.latitude < -90 || gpsCoords.latitude > 90 || gpsCoords.longitude < -180 || gpsCoords.longitude > 180) {
      return {
        latitude: 0,
        longitude: 0,
        accuracy: 0
      };
    }

    // Calculate correct UTM zone from longitude
    const utmZone = Math.floor((gpsCoords.longitude + 180) / 6) + 1;

    // Determine hemisphere from latitude
    const isNorth = gpsCoords.latitude >= 0;

    // Build projection string
    const southParam = isNorth ? '' : ' +south';
    const projectionString = `+proj=utm +zone=${utmZone}${southParam} +ellps=WGS84 +datum=WGS84 +units=m +no_defs`;

    // Convert GPS to UTM
    const [easting, northing] = proj4(projectionString).forward([gpsCoords.longitude, gpsCoords.latitude]);

    // Validate result
    if (!isFinite(easting) || !isFinite(northing)) {
      return {
        latitude: 0,
        longitude: 0,
        accuracy: 0
      };
    }
    return {
      longitude: easting,
      // UTM Easting
      latitude: northing,
      // UTM Northing
      accuracy: gpsCoords.accuracy || 0
    };
  } catch (error) {
    return {
      latitude: 0,
      longitude: 0,
      accuracy: 0
    };
  }
};